import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";

/**
 * Mutation hook for fetching a random video during break.
 * Consumers call `mutate(category)` where category is a video type key.
 */
export function useGetRandomVideo() {
  const $ = _c(5);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = category => apiFetcher(`/api/v1/sessions/video/${category}`);
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["getRandomVideo"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = {
      mutationFn: t0,
      mutationKey: t1
    };
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useMutation(t2);
}

/**
 * Mutation hook for recording a break activity (water, walk, etc.).
 */
export function useBreakActivity() {
  const $ = _c(5);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = category => apiFetcher(`/api/v1/sessions/activity/${category}`);
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["breakActivity"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = {
      mutationFn: t0,
      mutationKey: t1
    };
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useMutation(t2);
}